
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import Proxyable from 'vuetify/lib/mixins/proxyable'

  interface DropDownItem {
    id: number
    text: string
  }

  @Component({
    mixins: [Proxyable],
  })
  export default class MaterialDropdown extends Vue {
    @Prop({type: String, default: 'primary'}) private readonly color!: string
    @Prop({type: Array, default: () => ([])}) private readonly items!: DropDownItem[]
    @Prop({type: String, default: 'scale-transition'}) private readonly transition!: string
  }
